import React, { useState, useEffect } from "react";
import { apolloClient } from "../../..";
import { gql } from "@apollo/client";

import { getIntials, getName } from "../../../helper";
import ProfileWithName from "../../ListView/ListViewRows/ProfileWithName/ProfileWIthName";

const SharedWithTab = (props) => {
  const isPopover = false;
  const [sharedUser, setSharedUser] = useState([]);
  const [error, setError] = useState("");
  useEffect(() => {
    const variables = {
      folderId: props.folderDetails.id,
    };
    apolloClient
      .query({
        query: gql`
          query FolderSharedWith($folderId: UUID!) {
            folderSharedWith(folderId: $folderId) {
              user {
                id
                profile {
                  image
                }
                firstName
                lastName
                username
              }
              userRole {
                id
                name
              }
            }
          }
        `,
        variables: variables,
      })
      .then((result) => {
        const folder = props.folderDetails;
        const defaultUser = {
          user: {
            id: folder.createdBy.id,
            username: folder.createdBy.username,
            firstName: folder.createdBy.firstName,
            lastName: folder.createdBy.lastName,
            profile: { image: folder.createdBy.profile.image },
            __typename: "UserType",
          },
          userRole: {
            id: folder.createdBy.id,
            name: "Owner",
            __typename: "RoleType",
          },
        };
        setSharedUser([defaultUser, ...result.data.folderSharedWith]);
      })
      .catch((e) => {
        setError(e.message);
      });
  }, [props.shared, props.folderDetails]);

  const getContentRole = (userRoleId, type) => {
    const folder = props.folderDetails;
    if (userRoleId === 1 || userRoleId === 2) {
      return true;
    } else if (folder) {
      const createUserId = folder.createdBy.id;
      const logUserId = props.currentUserInfo.id;
      let returnedVal;
      if (logUserId === createUserId) {
        returnedVal = true;
      } else {
        const updatedSharedUsers = sharedUser.map((shareUser) => {
          return {
            id: shareUser.user.id,
            role: shareUser.userRole.name,
          };
        });
        const getAccess = updatedSharedUsers.find(
          (shareUser) =>
            shareUser.id === logUserId &&
            (shareUser.role === "Owner" || shareUser.role === "Collaborator")
        );
        returnedVal = getAccess ? true : false;
      }
      return returnedVal;
    }
  };

  return error ? (
    <div className="text-center mt-10">{error}</div>
  ) : (
    <div>
      {getContentRole(props.userRoleId, "Collaborator") ? (
        <div className="folder-details-share mr-6 mt-6">
          <button
            type="button"
            className="btn-secondary"
            onClick={() => props.shareToggle(props.folderDetails)}
          >
            Share
          </button>
        </div>
      ) : null}
      <div className="table-responsive shared-with-table mb-6">
        <table className="table table-hover">
          <thead className="table-borderless">
            <tr>
              <th scope="col">
                <label>Users</label>
              </th>
              <th scope="col">
                <label>Access</label>
              </th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {sharedUser.map((uKey, index) => (
              <tr>
                <td>
                  <ProfileWithName
                    sKey={uKey.id}
                    nameIntial={getIntials(uKey.user)}
                    personName={getName(uKey.user)}
                    profile={uKey.user.profile.image}
                    isPopover={isPopover}
                  />
                </td>
                <td>{uKey.userRole.name}</td>
                <td>
                  {/* {index !== 0
                    ? getContentRole(props.userRoleId, "") && (
                        <Dropdown isDocumentTemplate={true} />
                      )
                    : null} */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SharedWithTab;
